import React, { useEffect, useState } from "react";
import "./Factor.css";
import axios from "axios";
import { toast } from "react-toastify";
import Select, { components } from "react-select";
import AfterLoginNav from "../AfterLoginNav";
import { useNavigate } from "react-router-dom";
import MangeDashboard from "./ManageDashboard";
import { getGoldBars, purchasePhysicalGold } from "../../services/gold-price";
import { getUserBalance } from "../../services/balance";
import { getSystemContents } from "../../services/statistics";
import { getCommoditiesList } from "../../services/commodities";
import { useMediaQuery } from "react-responsive";
import { toPersianNum } from "../../utils/persianNumbers";

export default function PhysicalGold() {
  const navigate = useNavigate();
  const [amount, setamount] = useState();
  const [balance, setBalance] = useState([]);
  const [bars, setBars] = useState([]);
  const [commodities, setCommodities] = useState([]);
  const [selectedCommodity, setSelectedCommodity] = useState({});
  const { SingleValue, Option } = components;
  const [isLoading, setIsLoading] = useState(false);
  const [sizeChoose, setSizeChoose] = useState();
  const [SoatBalance, setSoatBalance] = useState();
  const [GramBalance, setGramBalance] = useState();
  const [physicalGoldText, setPhysicalGoldText] = useState("");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  useEffect(() => {
    function fetchData() {
      getCommoditiesList().then((data) => {
        const tmpBalance = [];
        if (data.status === 200) {
          setCommodities(data.data.results);
          setSelectedCommodity(data.data.results[0]);
          for (let el of data.data.results) {
            getUserBalance(el.id).then((res) => {
              if (res.status == 200) {
                const data = res?.data?.data;
                const info = {};
                info.id = el.id;
                info.name = el.name;
                info.balance = data.gold_balance;
                info.color = el?.ui_data?.colors?.primary;
                tmpBalance.push(info);

                setBalance([...tmpBalance]);
              }
            });
          }
        }
      });
      getUserBalance().then((res) => {
        const data = res?.data?.data;
        if (res.status == 200) {
          const gram = (data.gold_balance + "").split(".")[0];
          const soat = (
            (!isNaN((data?.gold_balance + "").split(".")[1]) &&
            (data?.gold_balance + "").split(".")[1] > 0
              ? Number((data?.gold_balance + "").split(".")[1])
              : 0) + ""
          ).substring(0, 3);
          setGramBalance(gram);
          setSoatBalance(
            soat.length === 1 && soat != 0
              ? soat * 100
              : soat.length === 2
              ? soat * 10
              : soat
          );
        }
      });
    }
    fetchData();
  }, []);
  useEffect(() => {
    if (selectedCommodity && !isNaN(selectedCommodity.id))
      getGoldBars(selectedCommodity.id).then((res) => {
        if (res.status == 200) {
          let option = res?.data?.results;
          let optionss = option.map((opt) => {
            return { value: opt.amount, lable: opt.id };
          });

          setSizeChoose(optionss[0]);
          setBars(optionss);
        }
      });
  }, [selectedCommodity]);
  function handleSubmit() {
    setIsLoading(true);
    purchasePhysicalGold(amount, sizeChoose["lable"], selectedCommodity.id)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 201) {
          if (res.data) {
            toast.success("درخواست شما با موفقیت ثبت شد");
          }
        } else {
          toast.error(res.data.detail);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  }

  const onchangeSelect = (item) => {
    setSizeChoose(item);
  };

  const customStylesSelect = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "rgba(127,127,127,0.2)",
    }),

    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      backgroundColor: "rgba(127,127,127,0.2)",

      background: isFocused ? "#eaeaea" : isSelected ? "#fff" : undefined,

      zIndex: 1,
      color: isSelected ? "#000" : "#707070",
    }),
    singleValue: (provided) => ({
      ...provided,
    }),
  };

  function handleCacul(event) {
    let value = event.target.value;

    if (value >= 0) {
      setamount(value);
    }
  }

  const IconSingleValue2 = (props) => (
    <SingleValue {...props}>
      <span className={"text-large pl-1"}>{props.data.label}</span>
      <span className={"text-medium text-price pl-2"}>
        {props.data.value}گرمی{" "}
      </span>
    </SingleValue>
  );

  const IconOption2 = (props) => (
    <Option {...props}>
      <span className={"text-large pl-1"}>{props.data.label}</span>
      <span className={"text-medium text-price pl-2"}>
        {props.data.value}گرمی{" "}
      </span>
    </Option>
  );

  useEffect(() => {
    getSystemContents().then((res) => {
      if (res.status == 200) {
        let data = res?.data?.results;
        for (let item of data) {
          if (item.key === "request_physical_gold") {
            setPhysicalGoldText(item.value);
          }
        }
      }
    });
  }, []);

  return (
    <MangeDashboard>
      <>
        <AfterLoginNav title={"دریافت فیزیکی"} hasBack={() => navigate(-1)} />
        <div className="container margin-for-sandogh-container">
          <div className="row justify-content-center align-items-center">
            {isTabletOrMobile && (
              <div className="select-on-mobile-sandogh">
                <select
                  value={selectedCommodity.id}
                  onChange={(e) =>
                    setSelectedCommodity(
                      commodities.find((el) => el.id == e.target.value)
                    )
                  }
                >
                  {commodities.map((el) => (
                    <option value={el.id}>{el.name}</option>
                  ))}
                </select>
              </div>
            )}
            <div className="col-xl-12 col-md-8">
              {isTabletOrMobile ? (
                <div className={"mobile-sandogh-text-center"}>
                  {[...balance]
                    .filter((el) => el.id == selectedCommodity.id)
                    .map((el) => (
                      <div className="balance-row">
                        <div>مجموع {el.name} ی موجود در صندوق </div>
                        <div className="balance-amount-info">
                          {!isNaN(el.balance)
                            ? (el.balance + "").split(".")[0]
                            : ""}{" "}
                          گرم و{" "}
                          {(
                            (!isNaN((el.balance + "").split(".")[1]) &&
                            (el.balance + "").split(".")[1] > 0
                              ? Number((el.balance + "").split(".")[1])
                              : 0) + ""
                          ).substring(0, 3)}{" "}
                          سوت
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="existing-gold-amount">
                  <div className="gold-balance-info-row">
                    و زرینو مجموع موجودی طلا و نقره
                  </div>
                  {balance.map((el) => (
                    <div className="balance-row">
                      مجموع {el.name} موجود در صندوق{" "}
                      <span
                        className="balance-amount-info"
                        style={{
                          color: el.color.startsWith("#")
                            ? el.color
                            : "#" + el.color.split("#").join(""),
                        }}
                      >
                        {!isNaN(el.balance)
                          ? (el.balance + "").split(".")[0]
                          : ""}{" "}
                        گرم و{" "}
                        {(
                          (!isNaN((el.balance + "").split(".")[1]) &&
                          (el.balance + "").split(".")[1] > 0
                            ? Number((el.balance + "").split(".")[1])
                            : 0) + ""
                        ).substring(0, 3)}{" "}
                        سوت
                      </span>
                    </div>
                  ))}
                </div>
              )}
              <div className="sandogh-order-inputs">
                <div className="sandogh-order-input-item">
                  {selectedCommodity?.name !== "زرینو" && (
                    <>
                      <div className="label-for-sandogh-item">شمش</div>
                      <Select
                        styles={customStylesSelect}
                        components={{
                          SingleValue: IconSingleValue2,
                          Option: IconOption2,
                        }}
                        options={bars}
                        onChange={onchangeSelect}
                        value={sizeChoose}
                      />
                    </>
                  )}
                </div>
                {!isTabletOrMobile && (
                  <div className="sandogh-order-input-item">
                    <select
                      value={selectedCommodity.id}
                      onChange={(e) =>
                        setSelectedCommodity(
                          commodities.find((el) => el.id == e.target.value)
                        )
                      }
                    >
                      {commodities.map((el) => (
                        <option value={el.id}>{el.name}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="sandogh-order-input-item">
                  <div className="label-for-sandogh-item">تعداد</div>
                  <input
                    type="number"
                    name="amount"
                    id={"amount"}
                    className="amount-input-sandogh"
                    value={amount}
                    onChange={handleCacul}
                  />
                </div>
              </div>

              <div className="terms-in-sandogh">
                <h5 className="title-of-sandogh-terms">{physicalGoldText}</h5>
              </div>

              <button
                disabled={selectedCommodity.name === "زرینو"}
                className="form-input-button-custom"
                onClick={handleSubmit}
              >
                {isLoading ? (
                  <img src={"./loading.svg"} alt={""} className={"w-loading"} />
                ) : (
                  <>
                    دریافت {selectedCommodity?.name === "زرینو" ? "" : "شمش"}{" "}
                    {toPersianNum(selectedCommodity?.name)}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </>
    </MangeDashboard>
  );
}
